import { RootState } from 'editor/src/store/index';

const getSpreadForegroundImage = (state: RootState, spreadName: string) =>
  state.design.spreadForegrounds?.find((foreground) => foreground.name === spreadName);

export default getSpreadForegroundImage;
